var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlarmActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3430_78742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6226 17.1014C23.1464 21.9402 25.2028 23.4025 25.2028 23.4025H9C9 23.4025 11.7005 21.4822 11.7005 14.761C11.7005 13.2331 12.2695 11.7678 13.2824 10.6874C14.2952 9.60696 15.669 9 17.1014 9C17.405 9 17.7061 9.02727 18.0016 9.08056",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4026 14.4009C24.8941 14.4009 26.1031 13.1919 26.1031 11.7005C26.1031 10.209 24.8941 9 23.4026 9C21.9111 9 20.7021 10.209 20.7021 11.7005C20.7021 13.1919 21.9111 14.4009 23.4026 14.4009Z",
    fill: "#FF567B",
    stroke: "#FF567B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6585 26.103C18.5002 26.3759 18.2731 26.6023 17.9998 26.7597C17.7265 26.9171 17.4166 27 17.1012 27C16.7858 27 16.476 26.9171 16.2027 26.7597C15.9294 26.6023 15.7022 26.3759 15.5439 26.103",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3430_78742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmActive);
export default __webpack_public_path__ + "static/media/icon-alarm-active.79e442bdfa522e935a3493ba483893f9.svg";
export { ForwardRef as ReactComponent };